import React from 'react';

import {
    TopLevelNavigationDropdownItem,
    TopLevelNavigationDropdownItemProps,
} from '../TopLevelNav/TopLevelNavigationDropdownItem';

export class ScrollableDropdown extends React.Component<TopLevelNavigationDropdownItemProps> {
    render() {
        return <TopLevelNavigationDropdownItem align="right" showArrow={false} {...this.props} />;
    }
}
export default ScrollableDropdown;
